<app-switch-template-form [template]="template" [type]="type"
    (templateUpdateNotifications$)="updateTemplateNotifications($event)"></app-switch-template-form>